import jwtAuthProvider from "./auth/jwtAuthProvider";

const authProvider = jwtAuthProvider();

export default authProvider;
